import {Component} from '@angular/core';
import {Subscription} from 'rxjs';
import {AuthService} from '../services/auth.service';

@Component({
  selector: 'app-nav',
  templateUrl: './app-nav.component.html',
  styleUrls: ['./app-nav.component.css']
})
export class AppNavComponent {
  public person_router_link;
  public visit_router_link;
  public loggedIn;
  subscription: Subscription;
  isOnboarding: boolean = false;

  constructor(private authService: AuthService) {
    this.visit_router_link = this.authService.getRequestRouterLink();
    this.person_router_link = this.authService.getPersonRouterLink();
    this.loggedIn = this.authService.loggedIn();

    this.subscription = authService.isLoggedIn$.subscribe(
      loggedIn => {
        this.loggedIn = loggedIn;
    });

    if (window.location.pathname.indexOf("/onboarding") > -1) {
      this.isOnboarding = true;
    }
  }

  isLoggedIn() {
    return this.authService.loggedIn();
  }

  logout() {
    this.authService.logout();
    this.loggedIn = false;
  }

  tutorial() {
    window.open("https://www.youtube.com/watch?v=weyHjHfFhMs", "_blank");
  }

  obtutorial() {
    // TODO: Get video link
    window.open("https://www.youtube.com/channel/UCYt2JN2z3ZXQpgPHt_eKcTw", "_blank");
  }

  isAdmin(){
    return this.authService.isAdmin();
  }
}

